exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CoverPosition-container .CoverPosition-content,.CoverPosition-container .CoverPosition-content-treeCardTable{display:flex;flex-direction:column;justify-content:center;align-items:center}.CoverPosition-container .CoverPosition-content-treeCardTable img{width:25px;height:25px}.CoverPosition-container .CoverPosition-content-treeCardTable span{margin-left:8px;font-size:13px;color:#aeaeae}", ""]);

// exports
